/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconCurrencyShekel = createReactComponent("currency-shekel", "IconCurrencyShekel", [
  ["path", { d: "M6 18v-12h4a4 4 0 0 1 4 4v4", key: "svg-0" }],
  ["path", { d: "M18 6v12h-4a4 4 0 0 1 -4 -4v-4", key: "svg-1" }]
]);

export { IconCurrencyShekel as default };
//# sourceMappingURL=IconCurrencyShekel.js.map
